import React, { Component } from 'react'
import { ContentHeader } from 'components/basic'
import { UserCreator } from 'projects/flow-gui-access/components/2.4'
import http from 'API/http'

class UserCreate extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null
    }
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='User' icon='fa-user' subtitle='Create new user' buttons={[ { icon: 'fa-arrow-left', event: () => (window.location.hash = '/users') } ]} />
        <hr />
        <div className='row'>
          <UserCreator />
        </div>
      </div>
    )
  }
}
export default UserCreate



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/users/create.js